/**
 * Formatting utility functions
 */

/**
 * Formats a price with currency
 * @param {number} price - The price to format
 * @param {string} currency - The currency symbol (default: 'zł')
 * @returns {string} - Formatted price
 */
export const formatPrice = (price, currency = 'zł') => {
  if (price === undefined || price === null) return '';
  
  return `${Number(price).toLocaleString('pl-PL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
};

export const formatDecimal = (decimal) => {
  if (decimal === undefined || decimal === null) return '';
  
  return `${Number(decimal).toLocaleString('pl-PL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};


/**
 * Formats a date
 * @param {string|Date} date - The date to format
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} - Formatted date
 */
export const formatDate = (date, options = {}) => {
  if (!date) return '';
  
  const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  return dateObj.toLocaleDateString('pl-PL', { ...defaultOptions, ...options });
};

/**
 * Truncates text to a specified length
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length
 * @returns {string} - Truncated text
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  
  if (text.length <= maxLength) return text;
  
  return `${text.substring(0, maxLength)}...`;
};

/**
 * Formats attribute name with unit in parentheses
 * @param {string} name - The attribute name
 * @param {string} jednostka - The unit (optional)
 * @returns {string} - Formatted attribute name
 */
export const formatAttributeName = (name, jednostka) => {
  if (!name) return '';
  
  if (jednostka && jednostka.trim() !== '') {
    return `${name} [${jednostka}]`;
  }
  
  return name;
};

export const formatAttributeValue = (itemAttributeValue) => {
  if (itemAttributeValue.dateValue) {
    return new Date(itemAttributeValue.dateValue).toLocaleDateString('pl-PL');
  } else if (itemAttributeValue.decimalValue !== null && itemAttributeValue.decimalValue !== undefined) {
    return formatDecimal(itemAttributeValue.decimalValue);
  } else if (itemAttributeValue.value) {
    return itemAttributeValue.value;
  }
  return 'nieznany typ';
};
